module.exports = __webpack_public_path__ + "img/6.95226845.jpg";